import OnboardingOverview from '@/views/Onboarding/OnboardingOverview.vue';
import type { RouteRecordRaw } from 'vue-router';

const onboardingRoutes: RouteRecordRaw[] = [
  {
    path: '/onboarding',
    name: 'Onboarding',
    component: OnboardingOverview,
    meta: {
      headerConfig: {
        headerLabel: 'onboarding',
        hide: false,
        showBack: true,
        showProfile: false,
      },
      footerConfig: {
        hide: true,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
      },
      containerMargins: true,
    },
  },
];

export default onboardingRoutes;
